module.exports = __webpack_public_path__ + "static/media/swaraj_963.8fcfc718.png";